module.exports = __webpack_public_path__ + "img/Gallery_2_35.d79aab98.jpeg";